<div class="my-10 flex flex-row justify-between align-bottom">
  <div>
    @if (event) {
      <h3 class="text-lg font-semibold">{{ event.name }}</h3>
      <p class="text-sm text-gray-600">Edit timeline item for event</p>
    }
  </div>
  <div class="w-1/2 flex justify-end px-2.5 align-bottom pt-6">
    <app-checkbox [control]="form.controls.is_published" [inline]="true" label="Published for customers"></app-checkbox>
  </div>
</div>

<div class="flex items-center justify-between">
  <h3 class="text-lg font-semibold">Timeline item info</h3>
</div>

<div class="-mx-2.5 mt-5 flex flex-wrap gap-y-5">
  <div class="w-full px-2.5">
    <app-text-input [control]="form.controls.name" [name]="'name'" [placeholder]="'Name'" label="Name"></app-text-input>
  </div>
  <div class="w-full px-2.5 xl:w-1/2">
    <app-date-picker [control]="form.controls.date" [name]="'departure'" [label]="'Date'"></app-date-picker>
  </div>
  <div class="w-full px-2.5 xl:w-1/2">
    <app-time-picker [control]="form.controls.time" [name]="'departure_time'" [label]="'Time'"></app-time-picker>
  </div>
  <div class="w-full px-2.5">
    <app-textarea [rows]="10" [control]="form.controls.description" [name]="'description'" [placeholder]="'Description'" label="Description"></app-textarea>
  </div>
</div>

<div class="mt-8">
  <app-select
    [height]="'12'"
    [multiple]="true"
    [searchable]="true"
    [control]="linkedProductItemIdsControl"
    [choices]="existingProductChoices"
    [label]="'Link Existing Finance Products'"
    [placeholder]="'Select products to link to this itinerary item'"
    [showSelectedTags]="false">
  </app-select>
</div>

<!-- Product management controlled by FeatureFlags.ITINERARY_PRODUCT_MANAGEMENT -->
@if (showProductManagement) {
  @if (productItems.length > 0) {
    <div class="flex items-center justify-between mt-10 mb-4">
      <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Product(s)</h3>
    </div>

    <div class="overflow-hidden rounded-lg border border-gray-200 dark:border-gray-800">
      <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-800">
        <thead class="bg-gray-50 dark:bg-gray-900/50">
          <tr>
            <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Product
            </th>
            <th scope="col" class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider w-32">
              Quantity
            </th>
            <th scope="col" class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider w-40">
              Price
            </th>
            <th scope="col" class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider w-24">
              Actions
            </th>
          </tr>
        </thead>
        <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
          @for (productItem of productItems; track productItem.id || $index) {
            <tr class="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
              <td class="px-4 py-3">
                <div class="flex flex-col gap-1">
                  <a
                    [routerLink]="['/products', productItem.product.id, 'edit']"
                    class="text-sm font-medium text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 hover:underline cursor-pointer">
                    {{ productItem.product.name }}
                  </a>
                  @if (productItem.variant_selections?.length) {
                    <div class="flex flex-wrap gap-1.5 mt-1">
                      @for (selection of productItem.variant_selections; track selection.id) {
                        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300">
                          {{ selection.variant?.name }}: {{ selection.variant_option?.name || 'Standard' }}
                          @if (selection.quantity > 1) {
                            <span class="ml-1 text-blue-600 dark:text-blue-400">×{{ selection.quantity }}</span>
                          }
                        </span>
                      }
                    </div>
                  }
                </div>
              </td>
              <td class="px-4 py-3 text-center text-sm text-gray-700 dark:text-gray-300">
                {{ productItem.quantity || 'N/A' }}
              </td>
              <td class="px-4 py-3 text-center">
                <span class="text-sm font-medium text-gray-900 dark:text-gray-100">
                  {{ getProductDisplayPrice(productItem) | currency: 'GBP' }}
                </span>
              </td>
              <td class="px-4 py-3">
                <div class="flex items-center justify-center gap-2">
                  <button
                    (click)="editItem(productItem)"
                    [disabled]="isEventConfirmed"
                    [title]="isEventConfirmed ? 'Cannot edit products for confirmed events' : 'Edit product'"
                    class="text-gray-500 hover:text-primary-500 dark:text-gray-400 dark:hover:text-primary-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:text-gray-500 transition-colors">
                    <lucide-icon [size]="18" [name]="EditIcon"></lucide-icon>
                  </button>
                  <button
                    (click)="removeProductItem(productItem.id, productItem)"
                    [disabled]="!canDeleteProduct(productItem)"
                    [title]="isEventConfirmed ? 'Cannot delete products from confirmed events' :
                             (isVenueHireProduct(productItem) && event.category === 'Wedding') ? 'Venue Hire is required for wedding events' :
                             'Delete product'"
                    class="text-gray-500 hover:text-error-500 dark:text-gray-400 dark:hover:text-error-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:text-gray-500 transition-colors">
                    <lucide-icon [size]="18" [name]="TrashIcon"></lucide-icon>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (!editProductItem) {
    <app-event-product-item-form
      [event]="event"
      (itemCreated)="productItemCreated($event)"
    ></app-event-product-item-form>
  } @else if (editProductItem) {
    <div class="mt-10">
      <app-event-product-item-edit-form
        [event]="event"
        [productItem]="editProductItem!"
        (itemUpdated)="productItemUpdated($event)"
        (formCancelled)="closeEditForm()"
      ></app-event-product-item-edit-form>
    </div>
  }
}

<div class="w-full mt-10 flex justify-end gap-3">
  <app-button [label]="'Save timeline item'" [disabled]="processing || !form.valid || form.pristine" (click)="save()"></app-button>
</div>
